export const encodeParameters = (params: { [key: string] : any }) => {
	const esc = encodeURIComponent;
	const query = Object.keys(params)
		.filter((key) => params[key])
		.map((k) => esc(k) + '=' + esc(params[k]))
		.join('&');
	return query;
};
